import Criteria from './Criteria'

export default class ServiceLocalItemFields extends Criteria{

}